import React from 'react';
import PropTypes from 'prop-types';

import withData from 'components/withData';

import { MetadataContext } from './';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		metadata: null,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				metadata: response.data,
			});
		}
	}

	render() {
		return (
			<MetadataContext.Provider value={this.state}>
				{this.props.children}
			</MetadataContext.Provider>
		);
	}
}

export const MetadataContextProvider = withData('/spend/metadata')(Provider);
